import React from "react";

interface PaymentButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  icon?: React.ReactNode;
  subText?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

const PaymentButton = ({
  children,
  onClick,
  className = "",
  icon,
  subText,
  disabled = false,
  type = "button",
}: PaymentButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`w-full rounded-xl border shadow-md px-4 py-5 flex flex-row items-center justify-start transition hover:shadow-lg active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {icon && (
        <div className="text-3xl flex-shrink-0 flex items-center justify-center">
          {icon}
        </div>
      )}
      <div className="flex flex-col items-center justify-center text-center w-full">
        <div className="text-lg mb-1">{children}</div>
        {subText && <div className="text-xs text-[#5E5E5E]">{subText}</div>}
      </div>
    </button>
  );
};

export default PaymentButton;
